import { z } from 'zod';

export const providerFormSchema = z.object({
  provider_name: z
    .string()
    .min(1, 'Name is required')
    .max(255, 'Name must be 255 characters or fewer'),
  provider_code: z
    .string()
    .min(3, 'Code must be at least 3 characters')
    .max(10, 'Code must be 10 characters or fewer')
    .regex(/^[A-Z0-9]+$/i, 'Code must contain only letters and numbers'),
  license_number: z
    .string()
    .max(100, 'License # must be 100 characters or fewer')
    .optional()
    .or(z.literal('')),
  party_role_id: z
    .number({ required_error: 'Role is required' })
    .int()
    .positive('Role is required'),
  party_status_id: z
    .number({ required_error: 'Status is required' })
    .int()
    .positive('Status is required'),
});

export type ProviderFormValues = z.infer<typeof providerFormSchema>;

export const flattenZodErrors = (error: z.ZodError): Partial<Record<string, string>> => {
  const result: Partial<Record<string, string>> = {};
  for (const issue of error.issues) {
    const key = issue.path[0];
    if (typeof key === 'string' && !result[key]) result[key] = issue.message;
  }
  return result;
};

export const formatProviderDate = (iso: string): string =>
  new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
